const theme = {
    fz: {
        XXXL: "6.4rem",
        XXL: "4.8rem",
        XL: "3.2rem",
        L: "2.8rem",
        M: "2.4rem",
        S: "2rem",
        XS: "1.8rem",
        XXS: "1.6rem",
        XXXS: "1.4rem",
        miniS: "1.2rem",
        normal: {
            big: "3.6rem",
            medium: "2.6rem",
            small: "2.4rem",
        },
        hola: {
            biggest: "11.2rem",
            big: "6.4rem",
            medium: "4.8rem",
            small: "4.2rem",
            mini: "4rem",
        },
    },
    fw: {
        light: "300",
        regular: "400",
        semiBold: "600",
        bold: "700",
        extraBold: "800",
    },
    ff: {
        Montserrat: "'Montserrat', 'Arial', 'sans-serif'",
        HolaB: "'Hola Bisou', 'Montserrat', 'Arial', 'sans-serif'",
    },
    colors: {
        black: "#0D0D0D",
        yellow: "#F2CB05",
        white: "#f5f5f5",
        dark_white: "#d0d0d0",
        grey: "#BFBFBF",
        dark_grey: "#757471",
        green: "#2A9D8F",
        red: "#e62c25",
    },
};

export default theme;
